import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import Clienti from "@/pages/Clienti";
import Commesse from "@/pages/Commesse";
import CommessaDetail from "@/pages/CommessaDetail";
import Listino from "@/pages/Listino";
import Contabilita from "@/pages/Contabilita";
import Subappalto from "@/pages/Subappalto";
import Anagrafiche from "@/pages/Anagrafiche";
import Benestare from "@/pages/Benestare";
import Fatture from "@/pages/Fatture";
import Utenti from "@/pages/Utenti";
import Attivita from "@/pages/Attivita";
import Impostazioni from "@/pages/Impostazioni";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading || user === null)
    return (
      <div className="h-screen w-full flex items-center justify-center bg-slate-50">
        <div className="h-10 w-10 rounded-full border-4 border-blue-200 border-t-blue-700 animate-spin" />
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function PublicRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user) return <Navigate to="/" replace />;
  return children;
}

function AdminRoute({ children }) {
  const { user } = useAuth();
  if (user && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="clienti" element={<AdminRoute><Clienti /></AdminRoute>} />
              <Route path="commesse" element={<Commesse />} />
              <Route path="commesse/:id" element={<CommessaDetail />} />
              <Route path="listino" element={<AdminRoute><Listino /></AdminRoute>} />
              <Route path="contabilita" element={<Contabilita />} />
              <Route path="subappalto" element={<Subappalto />} />
              <Route path="benestare" element={<Benestare />} />
              <Route path="fatture" element={<Fatture />} />
              <Route path="anagrafiche" element={<Anagrafiche />} />
              <Route path="attivita" element={<AdminRoute><Attivita /></AdminRoute>} />
              <Route path="utenti" element={<AdminRoute><Utenti /></AdminRoute>} />
              <Route path="impostazioni" element={<AdminRoute><Impostazioni /></AdminRoute>} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
